import api from "./api";

/**
 * SH008 — which service staff a sale channel offers.
 *
 * Separate from posStaff.service.js on purpose: that one manages the staff themselves,
 * this one only manages the assignment between a staff member and an outlet.
 *
 * Everything here is paginated and incremental. A salon chain can run to hundreds of
 * staff, and there is deliberately no "save the whole list" call — paired with a
 * paginated UI it would unassign everybody outside the page being saved.
 */
class BranchServiceStaffService {
  /**
   * Staff assigned to a branch, one page at a time.
   *
   * @param {{branch_id: number, search_keyword?: string, page?: number}} params
   */
  getList({ branch_id, search_keyword, page }) {
    return api.post("/merchant/branch-service-staff", {
      branch_id,
      search_keyword,
      page,
    });
  }

  /**
   * The merchant's staff who are NOT assigned to this branch — what the Add dialog
   * picks from.
   *
   * @param {{branch_id: number, search_keyword?: string, page?: number}} params
   */
  getAvailable({ branch_id, search_keyword, page }) {
    return api.post("/merchant/branch-service-staff/available", {
      branch_id,
      search_keyword,
      page,
    });
  }

  /**
   * @param {number} branchId
   * @param {number[]} staffIds
   */
  add(branchId, staffIds) {
    return api.post("/merchant/branch-service-staff/add", {
      branch_id: branchId,
      staff_ids: staffIds,
    });
  }

  /**
   * @param {number} branchId
   * @param {number[]} staffIds
   */
  remove(branchId, staffIds) {
    return api.post("/merchant/branch-service-staff/remove", {
      branch_id: branchId,
      staff_ids: staffIds,
    });
  }
}

export default new BranchServiceStaffService();
